import { render, staticRenderFns } from "./FacebookAccountSummary.vue?vue&type=template&id=a6a8d6e2&scoped=true&lang=pug"
import script from "./FacebookAccountSummary.js?vue&type=script&lang=js&external"
export * from "./FacebookAccountSummary.js?vue&type=script&lang=js&external"
import style0 from "./FacebookAccountSummary.sass?vue&type=style&index=0&id=a6a8d6e2&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a8d6e2",
  null
  
)

export default component.exports